import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2222 10.1818C18.2222 8.49408 17.5671 6.87505 16.4002 5.68164C15.3061 4.56273 13.8462 3.90411 12.3082 3.82617L12 3.81818C10.3498 3.81818 8.76672 4.48823 7.59983 5.68164C6.43293 6.87505 5.77778 8.49408 5.77778 10.1818C5.77778 12.1448 6.85937 14.261 8.26476 16.1495C9.62281 17.9743 11.1818 19.4512 12 20.1774C12.8182 19.4512 14.3772 17.9743 15.7352 16.1495C17.1406 14.261 18.2222 12.1448 18.2222 10.1818ZM20 10.1818C20 12.7579 18.6199 15.2754 17.1502 17.2504C15.66 19.2527 13.9646 20.8462 13.1155 21.5961C13.1003 21.6094 13.0846 21.6228 13.0686 21.6351C12.7991 21.8423 12.4782 21.966 12.1441 21.9938L12 22C11.6146 22 11.2395 21.872 10.9314 21.6351C10.9154 21.6228 10.8997 21.6094 10.8845 21.5961C10.0354 20.8462 8.33998 19.2527 6.84983 17.2504C5.38011 15.2754 4 12.7579 4 10.1818C4 8.01187 4.84259 5.93052 6.34288 4.39613C7.84317 2.86174 9.87827 2 12 2C14.1217 2 16.1568 2.86174 17.6571 4.39613C19.1574 5.93052 20 8.01187 20 10.1818Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7778 10.1818C13.7778 9.17766 12.9818 8.36364 12 8.36364C11.0182 8.36364 10.2222 9.17766 10.2222 10.1818C10.2222 11.186 11.0182 12 12 12C12.9818 12 13.7778 11.186 13.7778 10.1818ZM15.5556 10.1818C15.5556 12.1901 13.9637 13.8182 12 13.8182C10.0363 13.8182 8.44444 12.1901 8.44444 10.1818C8.44444 8.17351 10.0363 6.54545 12 6.54545C13.9637 6.54545 15.5556 8.17351 15.5556 10.1818Z",
			fill: "#1F4C5C"
		})
	]
});
const ForwardRef = forwardRef(SvgLocations);
export { ForwardRef as ReactComponent };
